import { useState, useEffect } from "react";
import { InputBox, SubmitButton, TextAreaBox } from "../../components/Input";
import { Link } from "react-router-dom";
import { API_URL } from "../../config";
import axios from "axios";
import { showToast } from "../../components/toast";
import CompanyHeader from "./CompanyHeader";

const PrintConfigForm = () => {
  const [formData, setFormData] = useState({
    p_company: "",
    p_address: "",
    p_email: "",
    p_phone: "",
    p_gstin: "",
    p_subject: "",
    p_message: "",
    p_notes: "",
    p_tnc: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("authToken");

  // Fetch data from an API or load it dynamically here
  const fetchCompany = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}settings/company/Configurations`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      setFormData(response.data.data || {});
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompany();
  }, []);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\+?\d+$/;

    if(!emailRegex.test(formData.p_email)) {
      showToast.error("Please enter a valid email address.");
      setLoading(false);
      return;
    }

    if (!phoneRegex.test(formData.p_phone)) {
      showToast.error("Phone must contain only numbers.");
      setLoading(false);
      return;
    }


    try {
      const response = await axios.post(
        `${API_URL}settings/company/configuration/save?id=${formData.id}`, // query param instead of path param
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success === true) {
        showToast.success(response.data.message);
        fetchCompany();
      } else {
        showToast.error(response.data.message);
      }
    } catch (error) {
      showToast.error("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        <CompanyHeader />
        <div className="panel panel-default with-rounded-corner with-shadow mt-3">
          <form
            onSubmit={handleSubmit}
            className="stdform"
            encType="multipart/form-data"
          >
            <div className="panel-heading border-0">
              <span className="panel-title">
                Edit Print Configurations Details
              </span>
            </div>
            <div className="panel-body">
              <div className="row">
                {/* Company Name */}
                <div className="col-md-4 mb-2">
                  <InputBox
                    label="Company Name"
                    fieldname="p_company"
                    value={formData.p_company}
                    onChange={handleChange}
                    placeholder="Enter Company Name"
                  />
                </div>

                {/* Company Email */}
                <div className="col-md-4 mb-2">
                  <InputBox
                    label="Company Email"
                    fieldname="p_email"
                    value={formData.p_email}
                    onChange={handleChange}
                    placeholder="Enter Company Email"
                  />
                </div>

                {/* Company Phone */}
                <div className="col-md-4 mb-2">
                  <InputBox
                    label="Company Phone"
                    fieldname="p_phone"
                    value={formData.p_phone}
                    onChange={handleChange}
                    placeholder="Enter Company Phone"
                  />
                </div>

                <div className="clearfix"></div>

                {/* Company GST No. */}
                <div className="col-md-4 mb-2">
                  <InputBox
                    label="Company GST No."
                    fieldname="p_gstin"
                    value={formData.p_gstin}
                    onChange={handleChange}
                    placeholder="Enter Company GST No."
                  />
                </div>

                {/* Company Address */}
                <div className="col-md-8 mb-2">
                  <TextAreaBox
                    label="Company Address"
                    fieldname="p_address"
                    value={formData.p_address}
                    onChange={handleChange}
                    placeholder="Enter Company Address"
                  />
                </div>

                {/* Invoice Email Subject */}
                <div className="col-md-12 mb-2">
                  <InputBox
                    label="Invoice Email Subject"
                    fieldname="p_subject"
                    value={formData.p_subject}
                    onChange={handleChange}
                    placeholder="Enter Invoice Email Subject"
                  />
                </div>

                {/* Invoice Email Message */}
                <div className="col-md-12 mb-2">
                  <TextAreaBox
                    label="Invoice Email Message"
                    fieldname="p_message"
                    value={formData.p_message}
                    onChange={handleChange}
                    placeholder="Enter Invoice Email Message"
                  />
                </div>

                {/* Print Notes */}
                <div className="col-md-12 mb-2">
                  <TextAreaBox
                    label="Print Notes"
                    fieldname="p_notes"
                    value={formData.p_notes}
                    onChange={handleChange}
                    placeholder="Enter Print Notes"
                  />
                </div>
                {/* Print Terms & Conditions */}
                <div className="col-md-12 mb-2">
                  <TextAreaBox
                    label="Print Terms & Conditions"
                    fieldname="p_tnc"
                    value={formData.p_tnc}
                    onChange={handleChange}
                    placeholder="Enter Print Terms & Conditions"
                  />
                </div>
              </div>

              <div className="clearfix"></div>
              <SubmitButton
                pageBack="/Settings/Company"
                handleSubmit={handleSubmit}
              />
            </div>
          </form>
        </div>

        {/* Scroll to Top Button */}
        <Link to="#" data-click="scroll-top" className="btn-scroll-top fade">
          <i className="ti-arrow-up"></i>
        </Link>
      </div>
    </div>
  );
};

export default PrintConfigForm;
